/*
 * Copyright (c) 2020. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <https://veneliniliev.com>
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { extract } from '@app/core';
import { MenuService } from '@app/core/menu/menu.service';
import { Shell } from '@app/shell/shell.service';
import { ActivityListComponent } from '@app/reports/activity-list/activity-list.component';
import { CheckInOutComponent } from '@app/reports/check-in-out/check-in-out.component';
import { ClosedSalesComponent } from '@app/reports/closed-sales/closed-sales.component';
import { TimeTrackingComponent } from '@app/reports/time-tracking/time-tracking.component';
import { UserAssignmentsComponent } from '@app/reports/user-assignments/user-assignments.component';
import { UserCallsComponent } from '@app/reports/user-calls/user-calls.component';

const routes: Routes = [
  Shell.childRoutes([
    { path: 'time-tracking', component: TimeTrackingComponent, data: { title: extract('Working time') } },
    { path: 'check-in-out', component: CheckInOutComponent, data: { title: extract('Check in/out') } },
    { path: 'activity', component: ActivityListComponent, data: { title: extract('Activity') } },
    { path: 'closed-sales', component: ClosedSalesComponent, data: { title: extract('Closed sales') } },
    { path: 'user-assignments', component: UserAssignmentsComponent, data: { title: extract('User assignments') } },
    { path: 'user-calls', component: UserCallsComponent, data: { title: extract('User calls') } },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportsRoutingModule {
  constructor(menuService: MenuService) {
    menuService
      .addItem({ key: 'reports', title: 'Reports', icon: 'fal fa-chart-line' })
      .addItem({
        key: 'reports.time-tracking',
        title: 'Working time',
        requiredPermission: 'time_tracking.menu',
        path: '/time-tracking',
      })
      .addItem({
        key: 'reports.check-in-out',
        title: 'Check in/out',
        // No requiredPermission: every authenticated user can open their own report.
        path: '/check-in-out',
      })
      .addItem({
        key: 'reports.activity',
        title: 'Activity',
        requiredPermission: 'activities.menu',
        path: '/activity',
      })
      .addItem({
        key: 'reports.closed-sales',
        title: 'Closed sales',
        requiredPermission: 'sales.menu',
        path: '/closed-sales',
      })
      .addItem({ key: 'reports.user-assignments', title: 'User assignments', path: '/user-assignments' })
      .addItem({ key: 'reports.user-calls', title: 'User calls', path: '/user-calls' });
  }
}
